import styled from 'styled-components';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import AttachmentItem from '@/features/Commons/AttachmentItem';
import useAttachmentStore from '@/stores/AttachmentStore';
import useModalStore from '@/stores/pure/ModalStore';

interface Props {
  attachments: AttachmentT[];
  onDeleteAttachment?: (alias: string) => void;
}

const Attachment = ({ attachments, onDeleteAttachment }: Props) => {
  const { setSelectedAttachment, setAttachmentList } = useAttachmentStore(
    (state) => ({
      setSelectedAttachment: state.setSelectedAttachment,
      setAttachmentList: state.setAttachmentList,
    }),
  );
  const setModalStatus = useModalStore((state) => state.setModalStatus);

  const onAttachmentClick = (attachment: AttachmentT) => {
    setSelectedAttachment(attachment);
    setAttachmentList([]);
    setModalStatus('attachmentModal', true);
  };

  return (
    <SwiperContainer>
      <Swiper
        slidesPerView={'auto'}
        spaceBetween={12}
        navigation={true}
        modules={[Navigation]}
        style={{
          width: '100%',
          overflowY: 'visible',
          padding: '0px 16px 16px 16px',
          margin: '0 -16px',
        }}
      >
        {attachments.map((attachment: AttachmentT) => (
          <SwiperSlide key={attachment.alias} style={{ width: 156 }}>
            <AttachmentItem
              {...attachment}
              key={attachment.alias}
              onClick={() => onAttachmentClick(attachment)}
              onDeleteAttachment={onDeleteAttachment}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </SwiperContainer>
  );
};

const SwiperContainer = styled.div`
  position: relative;
  width: 100%;
  .swiper-button-prev,
  .swiper-button-next {
    top: 0;
    margin-top: 0;
    width: 60px;
    height: 100%;
    transition: all 0.2s;
  }

  .swiper-button-next {
    right: 0;
    background: linear-gradient(
      to right,
      transparent,
      ${(props) => props.theme.colors.gray100}
    );
  }
  .swiper-button-prev {
    left: 0;
    background: linear-gradient(
      to left,
      transparent,
      ${(props) => props.theme.colors.gray100}
    );
  }
  .swiper-button-next svg,
  .swiper-button-prev svg {
    width: 14px;
    height: 14px;
    padding: 8px;
    background: ${(props) => props.theme.colors.gray100};
    border-radius: 50%;
    box-shadow: ${(props) => props.theme.shadow[1]};
    color: ${(props) => props.theme.colors.gray700};
    border: 1px solid ${(props) => props.theme.colors.gray400};
  }

  .swiper-button-next svg {
    margin-right: -24px;
  }
  .swiper-button-prev svg {
    margin-left: -24px;
  }

  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    opacity: 0;
    cursor: auto;
    pointer-events: none;
  }
`;

export default Attachment;
